import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Theme } from '../data/theme.model';
import { ApiService } from '../data/api.service';
import { take, tap } from 'rxjs';
import { StoreService } from '../data/store.service';

export const themeResolver: ResolveFn<Theme> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(StoreService);

  return inject(ApiService)
    .getTheme(route.paramMap.get('key')!)
    .pipe(
      tap((theme) => {
        store.theme.set(theme);
      }),
      take(1),
    );
};
